<template>
  <Card>
    <FlexRow :space="4" class="pa-4" wrap style="gap: 16px">
      <FlexColumn>
        <FlexRow v-if="applicant.id">
          <Label size="h6" bold text="ID："/>
          <Label size="h6" bold :text="applicant.id"/>
          <Label size="h6" bold text="さん"/>
        </FlexRow>
        <FlexColumn v-else :space="0">
          <FlexRow>
            <Label size="caption" bold :text="`${applicant.lastNameKana} ${applicant.firstNameKana}`"/>
          </FlexRow>
          <FlexRow>
            <Label size="h6" bold :text="`${applicant.lastName} ${applicant.firstName}`"/>
            <Label size="h6" bold text="さん"/>
          </FlexRow>
          <FlexRow>
            <Label size="body-1" bold text="(ID："/>
            <Label size="body-1" bold :text="applicant.anonymousId"/>
            <Label size="body-1" bold text="さん)"/>
          </FlexRow>
        </FlexColumn>
        <FlexRow v-if="applicant.competitionResults.rank" align="baseline">
          <Label text="Nishikaスコア:"/>
          <Label bold text="上位"/>
          <Label bold :text="applicant.competitionResults.rank"/>
          <Label bold text="%"/>
        </FlexRow>
        <CompetitionMedals
          :gold="applicant.competitionResults.medals.gold"
          :silver="applicant.competitionResults.medals.silver"
          :bronze="applicant.competitionResults.medals.bronze"
        />
      </FlexColumn>
      <FlexColumn v-if="applicant.age">
        <FlexRow>
          <Label text="年齢："/>
          <Label :text="applicant.age"/>
          <Label text="歳"/>
        </FlexRow>
        <FlexRow v-if="applicant.salary">
          <Label text="現年収："/>
          <Label :text="applicant.salary"/>
          <Label text="万円"/>
        </FlexRow>
        <FlexRow v-if="applicant.changeJobMotivation">
          <Label text="転職意欲："/>
          <ChangeJobMotivationLabel :motivation="applicant.changeJobMotivation" />
        </FlexRow>
        <FlexRow v-if="applicant.lastLoggedInAt">
          <Label text="最終ログイン："/>
          <LastLoggedInLabel :lastLoggedInAt="applicant.lastLoggedInAt" />
        </FlexRow>
      </FlexColumn>
    </FlexRow>
  </Card>
</template>

<script>
import FlexRow from "@/components/atoms/FlexRow";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import CompetitionMedals from "@/components/molecules/CompetitionMedals";
import ComponentMixin from "@/components/ComponentMixin";
import ChangeJobMotivationLabel from "@/components/molecules/ChangeJobMotivationLabel";
import LastLoggedInLabel from "@/components/molecules/LastLoggedInLabel";
import Card from "@/components/atoms/Card";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantSummaryView",
  components: {LastLoggedInLabel, ChangeJobMotivationLabel, CompetitionMedals, Label, FlexColumn, FlexRow, Card},
  props: {
    applicant: {
      type: Object
    }
  },
}
</script>

<style scoped>

</style>
